import React from 'react';
import c from './placeholder.module.scss';
import nothingToSee from './nothing-to-see.png';
import hiddenPage from './hidden-page.png';
import PageSettingsWrapper from '@/components/ui/nav/page-nav/page-settings-wrapper/PageSettingsWrapper';

const Placeholder = ({ onHiddenPage }) => {
  return (
    <div className={c.placeholder}>
      <img
        aria-hidden="true"
        alt=""
        src={onHiddenPage ? hiddenPage : nothingToSee}
      />
      <div className={c.content}>
        <h1>{onHiddenPage ? 'This page is hidden' : 'Nothing to see here'}</h1>
        <div className={c.body}>
          <p>You can add and unhide pages using page management</p>
          <PageSettingsWrapper onPagePlaceholder={true} />
        </div>
      </div>
    </div>
  );
};

export default Placeholder;
